/**
 * Instagram Feed Component - Handles reveal on scroll animation
 */
class InstagramFeed extends HTMLElement {
  constructor() {
    super();
    
    // Only add animation if user prefers motion
    if (window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
      this.initRevealAnimation();
    }
  }
  
  initRevealAnimation() {
    // Use Intersection Observer to detect when the element comes into view
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.reveal();
          observer.unobserve(this);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '50px'
    });
    
    observer.observe(this);
  }
  
  reveal() {
    const items = this.querySelectorAll('[reveal-on-scroll="true"]');
    
    items.forEach((item, index) => {
      // Remove the attribute so animation doesn't run again
      item.removeAttribute('reveal-on-scroll');
      
      // Set initial state
      item.style.opacity = '0';
      item.style.transform = 'translateY(24px)';
      
      // Animate with delay
      setTimeout(() => {
        item.style.transition = 'opacity 1s cubic-bezier(0.22, 1, 0.36, 1), transform 1s cubic-bezier(0.22, 1, 0.36, 1)';
        item.style.opacity = '1';
        item.style.transform = 'translateY(0)';
      }, index * 50); // 50ms stagger delay
    });
  }
}

// Register the custom element
if (!window.customElements.get('instagram-feed')) {
  window.customElements.define('instagram-feed', InstagramFeed);
}

